import React from "react";

function DeleteConfirmModal({ onConfirm, onCancel, name }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg p-6 min-w-[300px]">
        <div className="text-lg font-semibold mb-4 text-red-700">
          {name ? `Delete "${name}"?` : "Confirm delete?"}
        </div>
        <div className="flex gap-4 justify-center mt-2">
          <button
            onClick={onConfirm}
            className="bg-red-500 text-white font-semibold py-2 px-4 rounded-lg hover:bg-red-400 transition"
          >
            Yes
          </button>
          <button
            onClick={onCancel}
            className="bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg hover:bg-gray-200 transition"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
